// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "a[data-v-3de8e330],a[data-v-3de8e330]:link{color:#0062bd}.v-breadcrumbs[data-v-3de8e330]{padding:3px 20px;background:#f6f6f6}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
